var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12h16M14 7l6 5-6 5",
    stroke: "#9AA0AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M4 12H20' stroke='%239AA0AB' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M14 7L20 12L14 17' stroke='%239AA0AB' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";